import React from "react";

const ArrowRightIcon = ({ className = "w-5 h-5 text-blue-600" }) => (
	<span className={`material-symbols-outlined ${className}`}>
		arrow_right_alt
	</span>
);

export default ArrowRightIcon;
